// ##### Komarov 2025-08-05
import { SET_PAGES_REDUX } from '../constants';

const initialState = {};

function setPages(state = initialState, action) {
  switch (action.type) {
    case SET_PAGES_REDUX:
      return !state[action.payload.language] ? {
        ...state,
        [Object.keys(action.payload)[0]]: action.payload[Object.keys(action.payload)[0]]
      } : state;
    default:
      return state;
  }
}

export default setPages;
